<form [formGroup]="hotelForm">
  <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
    <h6 class="fw-medium fs-16 mb-2">Book Hotel - Villas, Apartments & more.</h6>
  </div>
  <div class="d-lg-flex">
    <div class="d-flex  form-info">
      <div class="form-item dropdown">
          <app-city-picker
            label="City, Property name or Location"
            formControlName="customCityId"
            (citySection)="onCitySection($event)"
          ></app-city-picker>

      </div>

      <!-- Date Picker Container: Both Dates in One -->

      <div class="date-picker-container d-flex gap-2 align-items-stretch" style="position: relative;">
        <!-- Hidden Date Range Picker -->
        <input type="text"
          style="position: absolute; top: 0; left: 0; width: 1px; height: 1px; opacity: 0; pointer-events: none;"
          bsDaterangepicker
          #dateRangePicker="bsDaterangepicker"
          [bsConfig]="{
            adaptivePosition: true,
            containerClass: 'theme-default',
            minDate: bsValue,
            dateInputFormat: 'DD-MM-YYYY',
            rangeSeparator: ' - ',
            showWeekNumbers: false,
            selectFromOtherMonth: true
          }"
          (bsValueChange)="onDateRangeChange($event)" />

        <div class="form-item position-relative flex-fill">
          <label class="form-label fs-14 text-default mb-1" for="checkin-input">Check In</label>
          <input id="checkin-input" type="text" class="form-control datetimepicker"
            readonly
            [value]="getFormattedDate('checkin')"
            (click)="openDateRangePicker($event)"
            />
          <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 12px; top: 38px; color: #6c757d;"></i>
          <p class="fs-12 mb-0">{{ getDateLabel('checkin') }}</p>
        </div>

        <div class="form-item position-relative flex-fill">
          <label class="form-label fs-14 text-default mb-1" for="checkout-input">Check Out</label>
          <input id="checkout-input" type="text" class="form-control datetimepicker"
            readonly
            [value]="getFormattedDate('checkout')"
            (click)="openDateRangePicker($event)"
            />
          <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 12px; top: 38px; color: #6c757d;"></i>
          <p class="fs-12 mb-0">{{ getDateLabel('checkout') }}</p>
        </div>
      </div>

      <div class="form-item dropdown" formGroupName="roomAndGuest">
        <!-- Unified trigger: desktop uses Bootstrap dropdown, mobile opens overlay -->
        <div class="position-relative" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="menu" (click)="onTravellerToggle($event)">
          <span class="form-label fs-14 text-default mb-1">Guests</span>
          <h5>{{ totalGuestCount }} <span class="fw-normal fs-14">{{ totalGuestCount === 1 ? 'Person' : 'Persons' }}</span></h5>
          <p class="fs-12 mb-0">{{ guestDesc }}</p>
          <i class="fa-solid fa-chevron-down" aria-hidden="true" style="position:absolute; right: 8px; bottom: 8px; color:#6c757d;"></i>
        </div>

        <!-- Desktop dropdown (hidden on mobile via CSS, like flight) -->
        <div class="dropdown-menu dropdown-menu-end dropdown-xl">
          <h5 class="mb-3">Select Travelers & Class</h5>
          <div class="mb-3 border br-10 info-item pb-1">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3 d-flex align-items-center justify-content-between">
                  <span class="form-label text-gray-9 mb-2">Rooms</span>
                  <app-common-counter formControlName="roomCount" [MIN]="1" [MAX]="9" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3 d-flex align-items-center justify-content-between">
                  <span class="form-label text-gray-9 mb-2">Adults</span>
                  <app-common-counter formControlName="adultCount" [MIN]="adultMin" [MAX]="adultMax" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3 d-flex align-items-center justify-content-between">
                  <span class="form-label text-gray-9 mb-2">Children <span class="text-default fw-normal">( 0-12 Yrs )</span></span>
                  <app-common-counter formControlName="childCount" [MIN]="childMin" [MAX]="childMax" />
                </div>
              </div>
              <div class="border-top col-md-12 ng-pristine ng-untouched ng-valid" formArrayName="child_age" *ngIf="childAgeFormArray().controls.length > 0">
                <p class="fs-14 mt-4">Please select the age for each child:</p>
                <div class="mb-3 d-flex align-items-center justify-content-between" *ngFor="let childAge of childAgeFormArray()?.controls; let j = index">
                  <span class="form-label text-gray-9 mb-2">Child {{ j + 1 }} <span class="text-default fw-normal">( 0-12 Yrs )</span></span>
                  <app-common-counter [formControlName]="j" [MIN]="1" [MAX]="12" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile fullscreen overlay (appears only on small screens) -->
        <div class="mobile-travellers-overlay" *ngIf="mobileTravellersOpen">
          <div class="mobile-travellers-panel">
            <button type="button" class="close-mobile" aria-label="Close" (click)="closeMobileTravellers()">✕</button>
            <h5 class="mb-3">Select Travelers & Class</h5>
            <div class="mb-3 border br-10 info-item pb-1">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3 d-flex align-items-center justify-content-between">
                    <span class="form-label text-gray-9 mb-2">Rooms</span>
                    <app-common-counter formControlName="roomCount" [MIN]="1" [MAX]="9" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3 d-flex align-items-center justify-content-between">
                    <span class="form-label text-gray-9 mb-2">Adults</span>
                    <app-common-counter formControlName="adultCount" [MIN]="adultMin" [MAX]="adultMax" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3 d-flex align-items-center justify-content-between">
                    <span class="form-label text-gray-9 mb-2">Children <span class="text-default fw-normal">( 0-12 Yrs )</span></span>
                    <app-common-counter formControlName="childCount" [MIN]="childMin" [MAX]="childMax" />
                  </div>
                </div>
                <div class="border-top col-12 ng-pristine ng-untouched ng-valid" formArrayName="child_age" *ngIf="childAgeFormArray().controls.length > 0">
                  <p class="fs-14 mt-4">Please select the age for each child:</p>
                  <div class="mb-3 d-flex align-items-center justify-content-between" *ngFor="let childAge of childAgeFormArray()?.controls; let j = index">
                    <span class="form-label text-gray-9 mb-2">Child {{ j + 1 }} <span class="text-default fw-normal">( 0-12 Yrs )</span></span>
                    <app-common-counter [formControlName]="j" [MIN]="1" [MAX]="12" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary search-btn rounded d-flex align-items-center justify-content-center" [disabled]="hotelForm.invalid || isLoading" (click)="onSearch()">
      <output *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" aria-live="polite"></output>
      <span *ngIf="!isLoading">Search</span>
      <span *ngIf="isLoading">Loading...</span>
    </button>
  </div>
</form>
